/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
/**
 * @ignore - internal component.
 */ const RadioGroupContext = /*#__PURE__*/ React.createContext(undefined);
if ("production" !== 'production') {
    RadioGroupContext.displayName = 'RadioGroupContext';
}
var _default = exports.default = RadioGroupContext;
